import classnames from "classnames";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button, { SIZE } from "components/Button";
import FormField from "components/FormField";
import userService from "services/user.service";
import userProfile from "services/user.profile";
import styles from "./Form.module.scss";

const Form = ({ uid, token, title }) => {
  const initialValues = {
    newPassword: "",
    confirmNewPassword: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({ ...formValues, [name]: value });
    setFormErrors({});
    setLoading(false);
  };

  const validate = (values) => {
    let errors = {};

    if (!values.newPassword && !values.confirmNewPassword) {
      errors.form = "These fields are required.";
    } else if (values.newPassword !== values.confirmNewPassword) {
      errors.form = "Passwords do not match. Try again";
    } else if (values.newPassword.length < 8) {
      errors.form = "This password is too short. It must contain at least 8 characters.";
    } else if (/^\d+$/.test(values.newPassword)) {
      errors.form = "This password is entirely numeric.";
    } else if (!/^(?=.*[a-z])(?=.*[A-Z]).*$/.test(values.newPassword)) {
      errors.form = "Password must contain at least 1 uppercase 1 lowercase";
    }

    return errors;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    setFormErrors(validate(formValues));

    Object.values(validate(formValues)).length === 0 &&
      (token
        ? userService.resetPasswordConfirm(uid, token, formValues.newPassword).then(
            (response) => {
              navigate("/login");
            },
            (error) => {
              const _content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();

              _content?.token?.[0]?.toLowerCase()?.includes("invalid") &&
                setFormErrors({ form: "Invalid token for given user." });
            },
          )
        : userProfile.accountCreateConfirm(uid, formValues.newPassword).then(
            (response) => {
              navigate("/login");
            },
            (error) => {
              const _content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();

              _content?.token?.[0]?.toLowerCase()?.includes("invalid") &&
                setFormErrors({ form: "Invalid token for given user." });
            },
          ));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>{title}</h1>
      </div>
      <form
        className={styles.form}
        method="POST"
        action="submit"
        onSubmit={handleOnSubmit}
      >
        <FormField
          type="password"
          fieldName="newPassword"
          labelText="New Password"
          value={formValues.newPassword}
          onChange={handleChange}
          className={styles.input}
          error={formErrors.form}
        />
        <FormField
          type="password"
          fieldName="confirmNewPassword"
          labelText="Confirm New Password"
          value={formValues.confirmNewPassword}
          onChange={handleChange}
          className={styles.input}
          error={formErrors.form}
        />
        <p
          className={classnames(
            styles.error_message,
            formErrors.length !== 0 && styles.active,
          )}
        >
          {formErrors.form}
        </p>

        <Button
          type="submit"
          size={SIZE.LARGE}
          className={styles.button}
          disabled={loading}
        >
          Submit
        </Button>
      </form>
    </div>
  );
};

export default Form;
